import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Button, Col, Collapse, Row } from 'antd';
import styled from 'styled-components';
import { device } from '../../lib/theme';
import { Title } from '../../components/styles';

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const { Panel } = Collapse;

const HighwaySafetyInitatives: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="AAA Carolinas | Driving Schools & Traffic Safety"
              description="If you have been charged with a moving violation in North Carolina, South Carolina or Virginia, you may be eligible to attend AAA’s Traffic Safety Course. Successful course completion may entitle you to a reduced charge or dismissal of your citation."
              image="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/uploads/2017/03/safetravel.jpg"
              canonicalUrl="/traffic-safety/highway-safety-initiatives"
            />
            <img
              style={{ width: '100%' }}
              src="https://prod-carolinas-aaa-com.azurewebsites.net/wp-content/uploads/2017/03/safetravel.jpg"
            />
            <Row style={{ marginTop: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title style={{ textAlign: 'center' }}>
                  Driving Schools & Traffic Safety
                </Title>
                <h3 style={{ marginTop: 32 }}>
                  ​<strong>Traffic Safety Courses</strong>
                </h3>
                <p>
                  Whether you have received a traffic ticket or just want to
                  sharpen your driving skills, AAA’s Traffic Safety Courses can
                  help! If you have been charged with a moving violation in
                  North Carolina, South Carolina or Virginia, you may be
                  eligible to attend AAA’s Traffic Safety Course. Successful
                  course completion may entitle you to a reduced charge or
                  dismissal of your citation. Contact the district attorney in
                  the county where you received your ticket for eligibility.
                </p>
                <h3>
                  <strong>Online Traffic Safety Course</strong>
                </h3>
                <ul>
                  <li>Take anytime, on your com​puter</li>
                  <li>
                    Complete at your leisure—site remembers where you stop
                  </li>
                  <li>Certificant is mailed to your home</li>
                  <li>
                    Support is available 24/7 by phone:{' '}
                    <a href="tel:18774761254">1-877-476-1254</a>
                  </li>
                </ul>
                <Button
                  type="primary"
                  href="http://northcarolina.aaadriverprogram.com/?lgr=5bd4e54e-7839-e611-9721-00155d007909"
                  style={{ marginTop: 16 }}
                >
                  Start Your Online Class
                </Button>
                <h3 style={{ marginTop: 32 }}>
                  <strong>In-Person Traffic Safety Course</strong>
                </h3>
                <ul>
                  <li>Taught by AAA-certified instructors</li>
                  <li>Available on Saturdays in 5-hour and 8-hour formats</li>
                  <li>Get your certificate at the end of the course</li>
                  <li>
                    Support is available 8:30am – 5:30pm M - F by phone:{' '}
                    <a href="tel:18882744459">1-888-274-4459</a>
                  </li>
                  <li>
                    <strong>
                      AHORA OFRECIENDO EN ESPAÑOL CLASES DE DEFENSA DE MANEJO EN
                      ANDES DRIVING SCHOOL
                    </strong>
                  </li>
                  <li>Several convenient locations:</li>
                  <Row>
                    <Col md={{ span: 8 }} xs={{ span: 24 }}>
                      <p>
                        <strong>AAA Headquarters</strong>
                        <br />
                        6600 AAA Drive
                        <br />
                        Charlotte, NC 28212
                      </p>
                    </Col>
                    <Col md={{ span: 8 }} xs={{ span: 24 }}>
                      <p>
                        <strong>Andes Driving School </strong>
                        <br />
                        5007 Southpark Drive
                        <br />
                        Suite 120
                        <br />
                        Durham, NC 27713
                      </p>
                    </Col>
                    <Col md={{ span: 8 }} xs={{ span: 24 }}>
                      <p>
                        {' '}
                        <strong>Exchange Club </strong>
                        <br />
                        331 Exchange Park Lane
                        <br />
                        Hillsborough, NC 27278
                      </p>
                    </Col>
                  </Row>
                </ul>
                <Button
                  type="primary"
                  href="https://drivingschool.carolinas.aaa.com/"
                >
                  Register Today!
                </Button>
                <h3 style={{ marginTop: 32 }}>
                  <strong>Driving Schools</strong>
                </h3>
                <p>
                  The AAA Approved Driving School Network (ADSN) is a network of
                  distinguished driving schools that meet AAA’s strict standards
                  and level of quality. Members of the Network offer a full line
                  of AAA approved services and AAA Members receive a member
                  discount. Contact your local school today for all of your
                  driver training needs.{' '}
                </p>
                <p>Approved Driving School Services include:</p>
                <ul>
                  <li>Teen Driver Courses</li>
                  <li>Behind-the-wheel Training</li>
                  <li>Point Reduction Courses (SC only)</li>
                  <li>Court Referral Courses</li>
                  <li>Driver Improvement Courses</li>
                  <li>Insurance Discount Courses</li>
                  <li>Senior Driver Course​s</li>
                  <li>Novice Driver Courses</li>
                  <li>Advanced Driving Courses</li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Row>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <Collapse defaultActiveKey={['1']} ghost>
                      <Panel header="List NC Schools" key="1">
                        <ul>
                          <li>
                            <strong>
                              BRAKES Teen Pro-Active Driving School
                            </strong>{' '}
                            <br />
                            <a
                              href="http://putonthebrakes.org/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.putonthebrakes.org
                            </a>{' '}
                            <br />
                            7140 Weddington Rd NW Ste 120,
                            <br />
                            Concord, NC 28027 <br />
                            <a href="tel:7047203806">704-720-3806</a>
                          </li>
                          <li>
                            <strong>
                              Carolina Road Driving Schoo​l: Raleigh{' '}
                            </strong>
                            <br />
                            <a
                              href="http://carolinaroaddriving.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.carolinaroaddriving.com
                            </a>{' '}
                            <br />
                            3755 Junction Blvd,
                            <br />
                            Raleigh NC 27603 <br />
                            <a href="tel:9192082922">919-208-2922</a>
                          </li>
                          <li>
                            <strong>
                              Carolina Road Driving Schoo​l: Greenville
                            </strong>{' '}
                            <br />
                            <a
                              href="http://carolinaroaddriving.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.carolinaroaddriving.com
                            </a>{' '}
                            <br />
                            3015 S. Memorial Drive
                            <br />
                            Greenville NC 27834 <br />
                            <a href="tel:2529160015">252-916-0015</a>
                          </li>
                          <li>
                            <strong>Safe Lane Driving School </strong>
                            <br />
                            <a
                              href="http://www.safelanedrivingschool.com"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.safelanedrivingschool.com
                            </a>{' '}
                            <br />
                            1230-8 E. Dixon Blvd,
                            <br />
                            Shelby, NC 28152 <br />
                            <a href="tel:7044817807">704-481-7807</a>
                          </li>
                          <li>
                            <strong>Drive! Driving School </strong>
                            <br />
                            <a
                              href="https://www.drivenorthcarolina.org"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.drivenorthcarolina.org
                            </a>{' '}
                            <br />
                            566 Midway Lake Rd,
                            <br />
                            Mooresville NC 28115 <br />
                            <a href="tel:7049287457">704-928-7457</a>
                          </li>
                          <li>
                            <strong>MotoMark1 </strong>
                            <br />
                            <a
                              href="https://www.motomark1.com"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.motomark1.com
                            </a>{' '}
                            <br />
                            2727 Tucker Street Ext.,
                            <br />
                            Burlington NC 27215 <br />
                            <a href="tel:9196370947">919-637-0947</a>
                          </li>
                        </ul>
                      </Panel>
                    </Collapse>
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <Collapse defaultActiveKey={['1']} ghost>
                      <Panel header="List SC Schools" key="2">
                        <ul>
                          <li>
                            <strong>123 Drive! Driving Academy</strong> <br />
                            <a
                              href="http://www.123drivedrivingacademy.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.123drivedrivingacademy.com
                            </a>{' '}
                            <br />
                            32 Office Park Road Suite 128,
                            <br />
                            Hilton Head Island SC 29928 <br />
                            <a href="tel:8432635023">843-263-5023</a>
                          </li>
                          <li>
                            <strong>843LetsDrive LLC</strong> <br />
                            <a
                              href="http://www.843letsdrive.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.843letsdrive.com
                            </a>{' '}
                            <br />
                            1016 N. Main St,
                            <br />
                            Summerville SC 29483 <br />
                            <a href="tel:8439911136">843-991-1136</a>
                          </li>
                          <li>
                            <strong>911 Driving School: Columbia</strong> <br />
                            <a
                              href="http://www.911drivingschool.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.911drivingschool.com
                            </a>{' '}
                            <br />
                            921 Longtown Rd Suite E,
                            <br />
                            Columbia SC 29229 <br />
                            <a href="tel:8046991191">803-699-1191</a>
                          </li>
                          <li>
                            <strong>911 Driving School: Fort Mill</strong>{' '}
                            <br />
                            <a
                              href="http://www.911drivingschool.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.911drivingschool.com
                            </a>{' '}
                            <br />
                            818 Tom Hall Street Suite 116,
                            <br />
                            Fort Mill SC 29715 <br />
                            <a href="tel:8033399110">803-339-9110</a>
                          </li>
                          <li>
                            <strong>911 Driving School: Rock Hill</strong>{' '}
                            <br />
                            <a
                              href="http://www.911drivingschool.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.911drivingschool.com
                            </a>{' '}
                            <br />
                            1348 Ebenezer Rd,
                            <br />
                            Rock Hill SC 29732 <br />
                            <a href="tel:8033399110">803-339-9110</a>
                          </li>
                          <li>
                            <strong>Advantage Driving School</strong> <br />
                            <a
                              href="http://www.advantagedrivingllc.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.advantagedrivingllc.com
                            </a>{' '}
                            <br />
                            7705 St. Andrews Rd, Suite C &amp; D,
                            <br />
                            Irmo SC 29063 <br />
                            <a href="tel:8037988400">803-798-8400</a>
                          </li>
                          <li>
                            <strong>Baldwin Driving School</strong> <br />
                            <a
                              href="http://www.baldwintraining.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.baldwintraining.com
                            </a>{' '}
                            <br />
                            3700 Baldwin Rd,
                            <br />
                            Columbia SC 29204 <br />
                            <a href="tel:8037865230">803-786-5230</a>
                          </li>
                          <li>
                            <strong>Carolina Traffic School</strong> <br />
                            <a
                              href="https://carolinatrafficschool.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              carolinatrafficschool.com
                            </a>{' '}
                            <br />
                            804 N. Oak St Ste C,
                            <br />
                            Myrtle Beach SC 29577 <br />
                            <a href="tel:8002178761">800-217-8761</a>
                          </li>
                          <li>
                            <strong>Drive Alert Training</strong> <br />
                            <a
                              href="http://drivealerttraining.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              drivealerttraining.com
                            </a>{' '}
                            <br />
                            1325 Miller Rd Ste. L,
                            <br />
                            Greenville SC 29607 <br />
                            <a href="tel:8642977878">864-297-7878</a>
                          </li>
                          <li>
                            <strong>aLord Ashley Driving School</strong> <br />
                            <a
                              href="https://www.alordashley.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.alordashley.com
                            </a>{' '}
                            <br />
                            105 Laurel Ave,
                            <br />
                            Goose Creek, SC 29445 <br />
                            <a href="tel:8438242040">843-824-2040</a>
                          </li>
                          <li>
                            <strong>Parnell's Driver Training</strong> <br />
                            <a
                              href="https://www.alordashley.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.parnellsdrivertraining.com
                            </a>{' '}
                            <br />
                            1811 South Irby St Suite 109
                            <br />
                            Florence SC 29505 <br />
                            <a href="tel:8439920048">843-992-0048</a>
                          </li>
                          <li>
                            <strong>Safe Driving School</strong> <br />
                            <a
                              href="http://safedrivingschoolinc.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              www.safedrivingschoolinc.com
                            </a>{' '}
                            <br />
                            4015 Belle Terre Blvd,
                            <br />
                            Myrtle Beach, SC 29579 <br />
                            <a href="tel:8434507233">843-450-7233</a>
                          </li>
                        </ul>
                      </Panel>
                    </Collapse>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ marginTop: 32, marginBottom: 64 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <h3>
                  <strong>Fleet Safety Courses</strong>
                </h3>
                <p>
                  Help your employees drive safer on company business with AAA
                  Driver Improvement Program Fleet Safety Courses. This program,
                  taught by a AAA certified instructor, is fully adaptable to
                  meet your company needs and may potentially save thousands of
                  dollars in fines, repairs, employee down time and insurance
                  costs.
                </p>
                <p>
                  <strong>Available Interactive Courses</strong>
                </p>
                <ul>
                  <li>Risk Management</li>
                  <li>Aggressive Driving &amp; Road Rage</li>
                  <li>Speed and Space Management</li>
                  <li>Vehicle Safety Technologies</li>
                  <li>Distracted Driving</li>
                  <li>Sharing the Road</li>
                  <li>Fuel-Efficient Driving</li>
                  <li>Adverse Conditions</li>
                  <li>Driving Emergencies </li>
                </ul>{' '}
                <p>
                  Contact the{' '}
                  <a href="https://carolinas.aaa.com/automotive/autobuying/contact-us/">
                    Traffic Safety
                  </a>{' '}
                  department today to find a AAA certified instructor near you.
                </p>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default HighwaySafetyInitatives;
